import { Paper, Typography } from "@mui/material";
import { Flex } from "~/components/Flex";
import { Link } from "react-router-dom";
import { CaseTicket } from "~/pages/tickets/types";
import { OpenInNew } from "@mui/icons-material";
import { ticketTypeIconMap } from "~/pages/tickets/ticket/TicketPage/utils/ticketPageUtils";
import { AttachIcon } from "~/icons";

type CaseTicketsProps = {
  tickets: CaseTicket[];
};

export const TicketTickets = ({ tickets }: CaseTicketsProps) => {
  return (
    <Flex sx={{ width: "100%", gap: 1, flexDirection: "column", mt: 2 }}>
      {tickets.map(({ description, href, id, type }) => {
        const Icon = ticketTypeIconMap[type] || AttachIcon;

        return (
          <Paper key={id} sx={{ px: 3, py: 1, flex: "1 0 auto" }}>
            <Flex
              justifyContent="space-between"
              component={href ? Link : undefined}
              {...(href && { to: href, target: "_blank", rel: "noreferrer" })}
            >
              <Flex>
                <Icon sx={{ mr: 2 }} />
                <Typography fontWeight={700}>{id}</Typography>
                {description && (
                  <Typography color="text.secondary" sx={{ ml: 0.5 }}>
                    {`– ${description}`}
                  </Typography>
                )}
              </Flex>
              {href && (
                <Link
                  to={href}
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "inline-flex" }}
                >
                  <OpenInNew color="primary" />
                </Link>
              )}
            </Flex>
          </Paper>
        );
      })}
    </Flex>
  );
};
